@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<h1 data-automation-name="powerTypeEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Powertype {{powertypeId}}</span>
    }
    @case(false) {
      <span>Register a new Powertype</span>
    }
  }
</h1>
<form name="powerTypeForm" class="form-horizontal" [formGroup]="powerTypeForm">
  <div class="form-group">
    <label for="itemDescription"> Item description: </label>
    <select id="itemDescription" class="form-control" name="itemLabel" type="select"
            formControlName="itemLabel" required>
      <option disabled selected value=""></option>
      @for(p of powertypeDescriptions; track p) {
        <option [value]="p" [selected]="powertype.itemLabel === p">{{p}}</option>
      }
    </select>
    @if(powerTypeForm.get('itemLabel')?.invalid && (powerTypeForm.get('itemLabel')?.dirty || powerTypeForm.get('itemLabel')?.touched)) {
      <div class="text-danger">
        <div *ngIf="powerTypeForm.get('itemLabel')?.errors?.['required']">Item description is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="itemUnit"> Item unit: </label>
    <select id="itemUnit" class="form-control" name="itemUnit" type="select"
            formControlName="itemUnit" required>
      <option disabled selected value=""></option>
      @for(u of item_units; track u) {
        <option [value]="u" [selected]="powertype.itemUnit === u">{{u}}</option>
      }
    </select>
    @if(powerTypeForm.get('itemUnit')?.invalid && (powerTypeForm.get('itemUnit')?.dirty || powerTypeForm.get('itemUnit')?.touched)) {
      <div class="text-danger">
        <div *ngIf="powerTypeForm.get('itemUnit')?.errors?.['required']">Item unit is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="scale_code"> SI Scale Code: </label>
    <select id="scale_code" class="form-control" name="siScaleCode" type="select"
            formControlName="siScaleCode">
      @for(sc of si_scale_codes; track sc) {
        <option [value]="sc.value" [selected]="powertype.siScaleCode === sc.value">{{sc.documentation}} ({{sc.value}})</option>
      }
    </select>
  </div>

  <div class="form-group">
    <label for="hertz"> Hertz: </label>
    <input id="hertz" class="form-control" name="hertz" type="number"
           formControlName="hertz" required>
    @if(powerTypeForm.get('hertz')?.invalid && (powerTypeForm.get('hertz')?.dirty || powerTypeForm.get('hertz')?.touched)) {
      <div class="text-danger">
        <div *ngIf="powerTypeForm.get('hertz')?.errors?.['required']">Hertz is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="voltage"> Voltage: </label>
    <input id="voltage" class="form-control" name="voltage" type="number"
           formControlName="voltage" required>
    @if(powerTypeForm.get('voltage')?.invalid && (powerTypeForm.get('voltage')?.dirty || powerTypeForm.get('voltage')?.touched)) {
      <div class="text-danger">
        <div *ngIf="powerTypeForm.get('voltage')?.errors?.['required']">Voltage is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="ac" class="form-check-label"> AC: </label>
    <br/>
    <input id="ac" class="form-check-input" name="ac" type="checkbox"
           formControlName="ac">
  </div>

  <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="powerTypeForm.invalid">Save</button>
  <a class="btn" (click)="backPage('/powertypes', router)">Cancel</a>
</form>
